import { graphql } from '@/graphql-setup'
import type { ResultOf } from 'gql.tada'

export const SALARY_ITEM_GENERATION_PREVIEW_QUERY = graphql(`
  query SalaryItemGenerationPreview($user: ID!, $year: Int!, $month: Int!) {
    salaryItemGenerationPreview(user: $user, year: $year, month: $month) {
      enabled
      live
      periodStart
      periodEnd
      outputs
      salaryWorkTimeName
      rows {
        output
        subject
        workPeriodId
        restPeriodId
        datetimeStart
        datetimeEnd
        action
        currentValue
        currentSalaryCode {
          id
          name
          externalId
        }
        currentTrace
        generatedValue
        generatedSalaryCode {
          id
          name
          externalId
        }
        generatedTrace
      }
    }
  }
`)

export const SALARY_GENERATION_RULES_LIVE_QUERY = graphql(`
  query SalaryGenerationRulesLive {
    salaryGenerationRulesLive
  }
`)

export type GenerationPreview = ResultOf<
  typeof SALARY_ITEM_GENERATION_PREVIEW_QUERY
>['salaryItemGenerationPreview']

export type GenerationPreviewRow = GenerationPreview['rows'][number]
